import React__default from 'react';
import { LabelCore } from '../shared/components/Label.mjs';
import { Typography } from './Typography.mjs';

const Label = (props)=>/*#__PURE__*/ React__default.createElement(LabelCore, {
        ...props,
        TypographyComponent: Typography
    });

export { Label };
//# sourceMappingURL=Label.mjs.map
